import script from "./BirthExplainer.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthExplainer.vue?vue&type=script&setup=true&lang=js"

import "./BirthExplainer.vue?vue&type=style&index=0&id=5007cd13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5007cd13"]])

export default __exports__